import gql from 'graphql-tag';

export const CREATE_FINANCIAL_ASSET_MUTATION = gql`
  mutation createFinancialAsset(
    $financialAssetInputDetails: FinancialAssetInput!
  ) {
    createFinancialAsset(financialAssetInput: $financialAssetInputDetails) {
      id
      testatorId
      investmentType
      otherInvestmentType
      institution
      displayName
      accountNumber
      specificDonation {
        id
      }
    }
  }
`;

export const UPDATE_FINANCIAL_ASSET_MUTATION = gql`
  mutation updateFinancialAsset(
    $id: ID!
    $financialAssetInputDetails: FinancialAssetInput!
  ) {
    updateFinancialAsset(
      id: $id
      financialAssetInput: $financialAssetInputDetails
    ) {
      id
      testatorId
      investmentType
      otherInvestmentType
      institution
      displayName
      accountNumber
      specificDonation {
        id
      }
    }
  }
`;

export const DELETE_FINANCIAL_ASSET_MUTATION = gql`
  mutation deleteFinancialAsset($id: ID!) {
    deleteFinancialAsset(id: $id) {
      id
    }
  }
`;
